import jsBridge from './utils/bridge.mjs';
import { API_SET_CACHE, API_GET_CACHE, VERSION_APP_UNSUPPORTED } from './utils/constant.mjs';
/**
 * 缓存数据
 * @param params
 * @returns
 */
export function setCache(params) {
    return jsBridge.callPromise({
        minVersion: VERSION_APP_UNSUPPORTED
    }, API_SET_CACHE, params);
}
/**
 * 获取缓存
 * @param params
 * @returns
 */
export function getCache(params) {
    return jsBridge.callPromise({
        minVersion: VERSION_APP_UNSUPPORTED
    }, API_GET_CACHE, params);
}
